import { html } from 'fxjs/es';
import { makeExpandableContainer } from '../../../Product/Detail/S/tmpl.js';
import { makeTgHead } from './BpInfo.js';

export const printGuide = ({ print_guide, is_mobile }) => html`
  <div class="toggle_cont toggle_cont_img print_guide" is_open="true">
    ${makeExpandableContainer({
      title: T('product_detail::Print Guide'),
      body: html` <div class="tg_head">${makeTgHead(T('product_detail::Print Guide'))}</div>
        <div class="tg_body">
          <div class="print_guide_text">${print_guide}</div>
        </div>`,
      disabled: !is_mobile,
    })}
  </div>
`;
